module.exports = __webpack_public_path__ + "01_bob_beige.bc227f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_bob_beige.png
// module id = wy6s
// module chunks = 0